import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { type AutoshipContent } from '../api';
import { AUTOSHIP_CONTENT_KEY, AUTOSHIP_MAP_RESTRICTED_CONTENT_KEY } from './queryKey';
export type UseAutoshipContentQueryResult = {
  autoshipContent: AutoshipContent | undefined;
  autoshipMapRestrictedContent: AutoshipContent | undefined;
};
export const useAutoshipContentQuery = () => {
  const $ = _c(7);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = queryClient.getQueryData([AUTOSHIP_CONTENT_KEY]);
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const autoshipContent = t0;
  let t1;
  if ($[2] !== queryClient) {
    t1 = queryClient.getQueryData([AUTOSHIP_MAP_RESTRICTED_CONTENT_KEY]);
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const autoshipMapRestrictedContent = t1;
  let t2;
  if ($[4] !== autoshipContent || $[5] !== autoshipMapRestrictedContent) {
    t2 = {
      autoshipContent,
      autoshipMapRestrictedContent
    };
    $[4] = autoshipContent;
    $[5] = autoshipMapRestrictedContent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};